import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogProgressReportTableComponent } from '../dialog-progress-report-table/dialog-progress-report-table.component';

@Component({
  selector: 'app-progress-repot-table',
  templateUrl: './progress-repot-table.component.html',
  styleUrls: ['./progress-repot-table.component.scss']
})
export class ProgressRepotTableComponent implements OnInit {
  @Input() parentData: any;
  showbipc: boolean;
  showMpc: boolean;

  BipcdisplayedColumns: any[] = [
    'testCode', 'testDate', 'total', 'totalMaxMarks', 'botany', 'physics',
    'chemistry', 'zoology',
  ];

  MpcdisplayedColumns: any[] = [
    'testCode', 'testDate', 'total', 'totalMaxMarks', 'maths', 'physics',
    'chemistry',
  ];
  selectedRow: any;
  @ViewChild(MatSort) sort: MatSort;
  // @ViewChild(MatPaginator) paginator: MatPaginator;

  // Define botanyHeader to be used in the template

  // botanyHeader: string = 'Botany';
  // botmaxmarksHeader: string = 'Bot Max Marks';
  // topBotnayHeader: string = 'Top Botany';
  // avgBotanyHeader: string = 'Avg Botany';
  // bRankHeader: string = 'B Rank';

  progressReport: any;
  bipcprogressReport: any;
  mpcprogressReport: any;

  ngOnInit(): void {
    console.log('PARENT-DATA', this.parentData);
    this.getTable();
  }

  constructor(public dialog: NgDialogAnimationService,) { }

  getTable() {
    if (this.parentData.studentMarks[0].group == "BIPC") {
      this.showbipc = true;
      this.showMpc = false;
      // this.setBotanyHeader()
      this.progressReport = new MatTableDataSource(this.parentData.studentMarks);
    }
    else if (this.parentData.studentMarks[0].group == "MPC") {
      this.showbipc = false;
      this.showMpc = true;
      this.progressReport = new MatTableDataSource(this.parentData.studentMarks);

      console.log('this.progressReport-mpc', this.mpcprogressReport);
    } else {
      console.log('DATA NOT FOUND');
    }
  }

  ngAfterViewInit() {
    this.progressReport.sort = this.sort;
    // this.progressReport.paginator = this.paginator;
  }


  // Set botanyHeader based on group type in parentData
  // setBotanyHeader(): void {
  //   if (this.parentData && this.parentData.some((row: any) => row.group)) {
  //     const group = this.parentData[0].group; // Assuming each row has the same group value
  //     this.botanyHeader = group === 'MPC' ? 'Maths' : 'Botany';
  //     this.botmaxmarksHeader = group === 'MPC' ? 'Math Max Marks' : 'Bot Max Marks';
  //     this.topBotnayHeader = group === 'MPC' ? 'Top Maths' : 'Top Botany';
  //     this.avgBotanyHeader = group === 'MPC' ? 'Avg Maths' : 'Avg Botany';
  //     this.bRankHeader = group === 'MPC' ? 'M Rank' : 'B Rank'
  //   }
  // }
  isSelected(row: any): boolean {
    return this.selectedRow === row;
  }

  allMarks(row: any) {
    this.selectedRow = row;
    const dialogRef = this.dialog.open(DialogProgressReportTableComponent,
      {
        data: row,
        height: '100%',
        width: '42%',
        direction: 'ltr',
        position: { right: '0px', top: '0px' },
        animation: { to: 'left' }
      }
    );
  }



}

